<script>
    import * as d3 from "d3";
    import * as hagrid from "@saehrimnir/hagrid";
    import { onMount } from "svelte";
    import legend from "d3-svg-legend";
    import { Delaunay } from "d3-delaunay";

    let width = 1;
    let height = 1;
    const margin = 20;
    let data = [];
    $: projection = hagrid.gridify(data.map(({x, y}) => [x, y]), "hilbert", {"pluslevel": 1});
    $: x = d3.scaleLinear().domain(d3.extent(projection, d => d[0])).range([margin, width - margin]);
    $: y = d3.scaleLinear().domain(d3.extent(projection, d => d[1])).range([margin, height - margin]);
    $: c = d3.scaleOrdinal(d3.schemeTableau10).domain(Array.from(new Set(data.map(d => d["condition"]))));
    $: s = d3.scaleOrdinal().domain(Array.from(new Set(data.map(d => d["track"])))).range(d3.symbols.map(s => d3.symbol(s, 1)));

    $: delaunay = Delaunay.from(projection.map(([px, py]) => [x(px), y(py)]));
    $: cells = delaunay.voronoi([0,0,width, height]);

    let zoom;
    let transform = {
        "x": 0,
        "y": 0,
        "k": 1,
    };

    onMount(async() => {
        width = height = Math.min(window?.innerWidth, window?.innerHeight - 60)
        data = await d3.csv(`${window.location.href}/data/comments.csv`, d3.autoType);
        filter_group = conditions = Array.from(new Set(data.map(d => d.condition)));
        zoom = d3.zoom()
            .filter((event) => {

                /* console.log(d3.event, event)
                if (d3.event.type === 'wheel') {
                    // don't allow zooming without pressing [ctrl] key
                    return d3.event.ctrlKey;
                } */

                return event.shiftKey;
                })
            .extent([[0, 0], [width, height]])
            .scaleExtent([0.5, 8])
            .on("zoom", zoomed);
        d3.select(viewerSvg).call(zoom);  
        //console.log(data);  
    })

    function zoomed({transform: T}) {
        transform = T;
        d3.select(viewerG).attr("transform", transform);
    }


    window.onresize = (event) => {
        event.stopPropagation();
        width = height = Math.min(window?.innerWidth, window?.innerHeight - 60)
    }

    let hovered = null;

    let legendSvgC;
    let legendSvgS;
    let viewerSvg;
    let viewerG;
    
    $: draw_legend(data)

    function draw_legend(data) {
        if (data.length == 0) return;
        c = d3.scaleOrdinal(d3.schemeTableau10).domain(Array.from(new Set(data.map(d => d["condition"]))));
        s = d3.scaleOrdinal().domain(Array.from(new Set(data.map(d => d["track"])))).range(d3.symbols.map(s => d3.symbol(s, 20)()));
        
        legend.legendColor()
            .title("Condition")
            .titleWidth(100)
            .scale(c)(d3.select(legendSvgC))
        
        d3.select(legendSvgS).attr("transform", `translate(${margin}, ${margin + legendSvgC.getBBox().height + margin})`);

        legend.legendSymbol()
            .title("Track")
            .titleWidth(100)
            .scale(s)(d3.select(legendSvgS))

        d3.select(legendSvgC.parentElement)
            .attr("height", legendSvgC.getBBox().height + legendSvgS.getBBox().height + 2 * margin)
            .attr("width", Math.max(legendSvgC.getBBox().width, legendSvgS.getBBox().width) + 2 * margin)
    }


    let tooltip;
    let mouse = {"x": 0, "y": 0};

    function filename(i, original="no") {
        const year = data[i].original_image.slice(0, 4)
        const condition = data[i].condition;
        const file = data[i].original_image.slice(5, -4);
        const file_end = data[i].original_image.slice(-3);
        const track = data[i].track;
        if (year == "2019") {
            const number_re = /\d+/;
            const number = number_re.exec(file)[0];
            return original == "original" 
                ? `${window.location.href}data/all_images/${year}_300/outputImages/${condition}/${track}_${condition}_${number}.${file_end}`
                : `${window.location.href}data/all_images/${year}_300/Original/${track}-${number}.${file_end}`
        } else {
            return original == "original"
                ? `${window.location.href}data/all_images/${year}_300/outputImages/${condition}/${file}_${condition}.${file_end}`
                : `${window.location.href}data/all_images/${year}_300/Original/${file}.${file_end}`
        }
    }


    let annotations = []


    let selecting = false;
    let new_annotation;

    let conditions = [];
    let filter_group = [];
</script>



<slot></slot>
<main>
    <svg width={window?.innerWidth} height={height} bind:this={viewerSvg}
        on:mousedown|preventDefault={(event) => {
            //console.log("mousedown", event, selecting)
            let {offsetX: mx, offsetY: my} = event;
            let tx = (mx - transform.x) / transform.k;
            let ty = (my - transform.y) / transform.k;
            if (!event.shiftKey && selecting == false) {
                hovered = null;
                selecting = true
                new_annotation = {
                    "path": [[tx, ty]], 
                    "text": ""
                };
            } else {
                
                
            }
        }}
        on:mouseup|preventDefault={(event) => {
            if (selecting) {
                //console.log("mouseup", selecting)
                let text = prompt("Please name the selection!", "Harry Potter")
                new_annotation.text = text;
                selecting = false;
                if (text) {
                    annotations.push(new_annotation)
                    annotations = annotations
                }
            }
            new_annotation = null;
        }}
        on:mousemove|preventDefault={(event) => {
            let {offsetX: mx, offsetY: my} = event;
            let tx = (mx - transform.x) / transform.k;
            let ty = (my - transform.y) / transform.k
            if (selecting == false) {
                let i = delaunay.find(tx, ty);
                hovered = (Math.hypot(tx - x(projection[i][0]), ty - y(projection[i][1])) < 50) ? i : null;
                mouse.x = mx;
                mouse.y = my;
                let w = 400;
                d3.select(tooltip)
                    .style("top", event.clientY > window.innerHeight / 2 ? null : event.pageY + 15 + "px")
                    .style("bottom", event.clientY > window.innerHeight / 2 ? (window.innerHeight - event.pageY) + 15 + "px" : null)
                    .style("left", Math.min(Math.max(0, event.clientX - w / 2), window.innerWidth - w) + "px");
            } else {
                new_annotation.path.push([tx, ty])
                new_annotation = new_annotation
                //console.log(new_annotation)
            }
        }}
        >
        <g bind:this={viewerG}
        >
            <g>
                {#each Array.from(cells.cellPolygons()) as cell, i}
                    <path d="M {cell.join(" ")} Z" fill="white"
                        >
                        <title>{data[i].comment}{"\n"}{JSON.stringify(data[i])}</title>
                    </path>
                {/each}
            </g>
            <g>
                {#each projection as [px, py], i}
                    <!-- <circle cx={x(px)} cy={y(py)} r=5 fill={c(data[i].papertype)}>
                    </circle> -->
                    <g transform="translate({x(px)}, {y(py)})" pointer-events="none" opacity={hovered ? (hovered == i ? 1 : 0.5) : 1}>
                        <path
                            d={s(data[i].track)}
                            fill={c(data[i].condition)}
                            opacity={filter_group.findIndex(f => f == data[i].condition) >= 0 ? 1 : 0.25}
                            />
                    </g>
                {/each}
            </g>





            <g>
                {#if new_annotation}
                    <path 
                        d="M {new_annotation.path.join(" ")}"
                        fill="none"
                        stroke="black"
                        stroke-dasharray="2 2"
                        >
                    
                    </path>
                {/if}

                {#each annotations as a, i}
                    <path 
                        d="M {a.path.join(" ")} Z"
                        fill="none"
                        stroke="black"
                        stroke-dasharray="2 2"
                        >
                    
                    </path>
                    <text 
                        x={d3.polygonCentroid(a.path)[0]}
                        y={d3.min(a.path, d => d[1]) - 10}
                        text-anchor="middle"
                        dominant-baseline="center"
                        >
                        {projection.filter(([px, py], i) => filter_group.findIndex(f => f == data[i].condition) >= 0 && d3.polygonContains(a.path, [x(px), y(py)])).length}× {a.text}
                    </text>
                    <rect 
                        x={d3.polygonCentroid(a.path)[0]}
                        y={d3.min(a.path, d => d[1]) - 10} width=10 height=10 
                        on:click={(event) => {
                            event.stopPropagation();
                            event.stopImmediatePropagation();
                            //console.log("click")
                            annotations.splice(i, 1);
                            annotations = annotations;
                        }}> 
                    </rect>
                {/each}

            </g>
        </g>
    </svg>

    <aside id="left">
        <div>
            Counter
            {#each conditions as c, i}
                <label>
                    <input type="checkbox" bind:group={filter_group} value={c}>
                    {c}
                </label>
            {/each}
            <svg width=200 height=500>
                <g transform="translate({margin}, {margin})" bind:this={legendSvgC}></g>
                <g transform="translate({margin}, {200 + margin})" bind:this={legendSvgS}></g>
            </svg>
            <br />
            <button on:click={() => d3.select(viewerSvg).call(zoom.transform, d3.zoomIdentity)}>reset zoom</button>
        </div>
    </aside>

    <aside id="right">
        <div  style="overflow-y: scroll; max-height: 80vh">
            {#each annotations as a, i}
                <div>
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                        <b>{a.text}</b>
                        <button on:click={() => {
                            annotations.splice(i, 1)
                            annotations = annotations;
                        }}>remove</button>
                    </div>
                    <small style="display: block; overflow-y: scroll; width: 200px; height: 100px;">{JSON.stringify(data.filter(d => filter_group.findIndex(f => f == d.condition) >= 0))}</small>
                    
                </div>
            {/each}
        </div>
    </aside>

    <div id="tooltip"
        bind:this={tooltip}
        style="visibility: {hovered ? 'visible' : 'hidden'}; border-left: 1em solid {hovered}">
        {#if hovered}
        <div style="width: {400}px; padding-right: 1em;">
            <h3><span style="">{data[hovered].condition}:</span> {data[hovered].original_image}</h3>
            <p style="font-size: 1.25em"><b>{data[hovered].type}:</b> {data[hovered].comment}</p>
            <div style="max-height:400px; width:400px; display: flex; gap: 10px">
                <div style="text-align: center; flex-grow: 1">
                    <b>Original</b><br>
                    <img style="max-height: 200px; max-width: 195px; height: auto; width: auto; margin-top: 0.5rem" src="{filename(hovered)}" alt=""/>
                </div>
                <div style="text-align: center; flex-grow: 1">
                    <b>{data[hovered].condition}</b><br>
                    <img style="max-height: 200px; max-width: 195px; height: auto; width: auto; margin-top: 0.5rem" src="{filename(hovered, "original")}" alt=""/>
                </div>  
            </div>
        </div>
        {/if}
    </div>
</main>


<style>
main {
    grid-row: 2 / 3;
    grid-column: 1 / 3;
    padding: 0;
    margin: 0;
    position: relative;
    overflow: hidden;
}

#left {
    position: absolute;
    bottom: 0rem;
    left: 0rem;
    padding: 0rem;
}

aside > div {
    background-color: #fff3;
    backdrop-filter: blur(10px);
    padding: 1rem;
}

#left > div {
    border-radius: 0 .5rem 0 0;
}


#right {
        position: absolute;
        bottom: 0rem;
        right: 0rem;
        padding: 0rem;
    }

#right > div {
    border-radius: .5rem 0 0 0;
}

#tooltip {
        font-size: 0.8rem;
        display: flex;
        position: absolute;
        pointer-events: none;
        padding: 1rem;
        background-color: #0003;
        color: black;
        backdrop-filter: blur(20px);
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
        border-radius: .5rem;
        z-index: 99999;
    }

    #tooltip h3 {
        margin-bottom: 0;
        padding-bottom: .5rem;
    }
</style>